// Types
import type { FormControlExpose } from "../types/formcontrol";

// Constants
import { FORM_CONTROL_FIELD_SYMBOL } from "../constants/symbols";

export default function useFormControl<TValue = unknown>() {
  return inject<FormControlExpose<TValue> | null>(
    FORM_CONTROL_FIELD_SYMBOL,
    null,
  );
}
